var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVsureLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "53px",
    viewBox: "0 0 200 53",
    enableBackground: "new 0 0 200 53",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M39.107,3.451C35.343,1.257,30.968,0,26.298,0c-8.064,0-15.252,3.748-19.92,9.597l13.79,37.541 L39.107,3.451z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#361B94",
    d: "M0.822,25.476c0,11.641,7.809,21.458,18.473,24.5L1.273,20.69C0.978,22.241,0.822,23.84,0.822,25.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#361B94",
    d: "M20.458,50.277c1.876,0.44,3.831,0.674,5.84,0.674c14.07,0,25.476-11.406,25.476-25.476 c0-3.608-0.752-7.041-2.104-10.151L20.458,50.277z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M75.206,37.192l9.537-21.525h6.131L75.206,49.793L59.472,15.667h6.198L75.206,37.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#361B94",
    d: "M112.748,12.949c-1.718-2.976-3.777-4.691-7.439-4.691c-3.834,0-7.152,2.747-7.152,6.695 c0,3.719,3.834,5.436,6.752,6.751l2.86,1.259c5.607,2.46,10.357,5.264,10.357,12.13c0,7.553-6.065,13.332-13.562,13.332 c-6.923,0-12.073-4.462-13.446-11.157l4.691-1.317c0.63,4.407,4.006,8.012,8.64,8.012c4.636,0,8.869-3.548,8.869-8.412 c0-5.035-3.947-6.751-7.953-8.583l-2.631-1.144c-5.036-2.289-9.385-4.864-9.385-11.043c0-6.695,5.665-10.987,12.074-10.987 c4.806,0,8.868,2.46,11.156,6.695L112.748,12.949z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#361B94",
    d: "M126.116,33.513c0,5.381,0.612,10.013,7.221,10.013c6.606,0,7.22-4.632,7.22-10.013V15.667h5.449v18.46 c0,8.514-3.201,14.441-12.669,14.441c-9.469,0-12.67-5.927-12.67-14.441v-18.46h5.449V33.513z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#361B94",
    d: "M155.814,19.141h0.136c1.907-2.521,3.543-4.359,7.085-4.359c1.84,0,3.338,0.613,4.904,1.499l-2.589,4.972 c-1.091-0.75-1.839-1.431-3.27-1.431c-5.994,0-6.267,7.697-6.267,11.853v16.007h-5.449V15.667h5.449V19.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#361B94",
    d: "M171.345,32.833c0.068,5.926,4.291,10.693,10.49,10.693c4.632,0,7.629-2.792,9.74-6.607l4.632,2.656 c-3.065,5.721-8.242,8.992-14.78,8.992c-9.537,0-15.667-7.289-15.667-16.484c0-9.468,5.518-17.301,15.53-17.301 c10.285,0,15.734,8.514,15.189,18.051H171.345z M190.758,28.2c-0.749-4.632-4.633-8.378-9.399-8.378 c-4.7,0-9.061,3.747-9.741,8.378H190.758z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsureLogo);
export default __webpack_public_path__ + "static/media/vsure-logo.b2b314c867c7591d0918437b946e4b35.svg";
export { ForwardRef as ReactComponent };